import React from 'react';
import LoginDijit from 'dijits/auth/loginContainer';

class LoginContainer extends React.Component {
    constructor(props) {
        super(props);

        this.loginDijit = new LoginDijit({ next: window.location.pathname });
    }

    componentDidMount() {
        this.loginDijit.placeAt(dojo.byId('LoginButton'));
    }

    render() {
        return <div id="LoginButton" className="right" />;
    }
}

export default LoginContainer;



// WEBPACK FOOTER //
// ./source/components/auth/LoginWrapper.jsx